module.exports = __webpack_public_path__ + "static/media/MS.1342217b.svg";